// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2o_Rj","icon":"SortAdornment_icon__3f-Bf","up":"SortAdornment_up__3NEhg","down":"SortAdornment_down__3S_dY","active":"SortAdornment_active__241k4"};